import { isDefined, isNil } from "@clipboard-health/util-ts";

import { WorkplaceType } from "../Workplace/constants";
import { isShiftShortLeadTime } from "./isShiftShortLeadTime";

interface IsArrivalTimeFeatureApplicableProps {
  shiftStartIso?: string;
  isInstantBook?: boolean;
  shortLeadTimeOffsetInHours: number;
  useExpectedArrivalTime: boolean;
  workplaceType?: string;
  workplaceId: string;
  workplaceMsa: string;
  workplaceExclusions: {
    msas: string[];
    workplaceIds: string[];
  };
}

/**
 * Checks if the shift is eligible for arrival time based on the shift start time and the arrival time config and if instant book is enabled.
 * It checks if the arrival time feature is enabled as well
 */
export function isArrivalTimeFeatureApplicable(props: IsArrivalTimeFeatureApplicableProps) {
  const {
    shiftStartIso,
    isInstantBook,
    shortLeadTimeOffsetInHours,
    useExpectedArrivalTime,
    workplaceType,
    workplaceId,
    workplaceMsa,
    workplaceExclusions,
  } = props;

  if (
    workplaceExclusions.msas.includes(workplaceMsa) ||
    workplaceExclusions.workplaceIds.includes(workplaceId)
  ) {
    return false;
  }

  if (isDefined(isInstantBook) && !isInstantBook) {
    return false;
  }

  if (!useExpectedArrivalTime) {
    return false;
  }

  if (!isDefined(shiftStartIso)) {
    return false;
  }

  const isShortLeadTime = isShiftShortLeadTime(shiftStartIso, shortLeadTimeOffsetInHours);

  if (!isShortLeadTime) {
    return false;
  }

  if (!isNil(workplaceType) && workplaceType === WorkplaceType.JOB_FAIR) {
    return false;
  }

  return true;
}
